var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?presets[]=es2015!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./status-value.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-21943872\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./status-value.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/js/components/status-value.vue
// module id = 560
// module chunks = 0